import { Reveal } from "./Reveal";

export const Verse = () => (
  <section className="py-20 lg:py-24 bg-cream" data-testid="verse-section">
    <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
      <Reveal>
        <p className="font-display italic text-2xl sm:text-3xl lg:text-4xl leading-snug text-forest/90">
          "He makes grass grow for the cattle, and plants for people to cultivate —
          bringing forth food from the earth."
        </p>
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-clay mt-6" data-testid="verse-reference">
          Psalm 104:14
        </p>
      </Reveal>
    </div>
  </section>
);
